export default __webpack_public_path__ + "static/media/rode.cabc696d.png";